export default __webpack_public_path__ + "static/media/youtube.5a115aed.svg";